import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';
// Remove missing CSS module import - using Tailwind classes instead

/**
 * Props for `FeaturesList`.
 */
export type FeaturesListProps = SliceComponentProps<Content.FeaturesListSlice>;

/**
 * Component for "FeaturesList" Slices.
 */
const FeaturesList = ({ slice }: FeaturesListProps): JSX.Element => {
  const {
    primary: {
      title,
      description,
      button_label: buttonLabel,
      go_to_slice: goToSlice,
      features,
    },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="max-w-screen-2xl mx-auto px-5 md:px-16 py-16 md:py-28"
    >
      <div className="max-w-[46rem] mx-auto flex flex-col gap-y-6 text-center">
        <div className="text-primary-shade-green">
          <PrismicRichText field={title} />
        </div>
        <div className="text-white text-medium-normal px-5 md:px-10">
          <PrismicRichText field={description} />
        </div>
      </div>
      {features.map((feature, index) => (
        <div
          key={`feature-${index}`}
          className={`flex flex-col ${feature.image_position === 'left' ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center text-white py-6 lg:py-12 gap-x-20 gap-y-6`}
        >
          <PrismicNextImage field={feature.image} />
          <div className="flex flex-col gap-y-6">
            <PrismicRichText field={feature.title} />
            <div className="text-medium-normal">
              <PrismicRichText field={feature.description} />
            </div>
          </div>
        </div>
      ))}
      {buttonLabel && (
        <div className="flex justify-center">
          <a href={`#${goToSlice}`} className="primary-button">
            {buttonLabel}
          </a>
        </div>
      )}
    </section>
  );
};

export default FeaturesList;
